import { useInfiniteQuery } from '@tanstack/react-query';
import { get } from '../api/api';
import { API_URLS } from '../constants/apiUrl';
import { QueryParamObject, toQueryString } from '../constants/utilityFunctions';
interface IUseFetchAllMatterRequests {
  relations?: string[];
  sortBy?: string[];
  extraFilters?: Record<string, string | number>;
  limit?: number;
  search?: string;
  fields?: string[];
  myOwn?: boolean;
}
export const useFetchAllMatterRequests = (params: IUseFetchAllMatterRequests) => {
  const fetchAllMatterRequests = async ({ pageParam = 1 }) => {
    const { relations: matterRequestRelations, extraFilters: filters, myOwn, ...rest } = params;
    const queryString = new URLSearchParams(
      Object.keys(rest)?.length ? toQueryString(rest as QueryParamObject) : '',
    );

    Object.entries(filters ?? {}).forEach(([key, value]) => {
      queryString.append(`filter.${key}`, String(value));
    });

    (matterRequestRelations ?? []).forEach((rel) => queryString.append('relations', rel));

    queryString.append('page', String(pageParam));
    try {
      return await get(
        `${myOwn ? API_URLS.MY_MATTER_REQUESTS : API_URLS.ALL_MATTER_REQUESTS}?${queryString.toString()}`,
      );
    } catch (error) {
      console.error('Error fetching all matter requests:', error);
      throw new Error(
        (error as { message: string }).message || 'Failed to fetch all matter requests',
      );
    }
  };

  const {
    data,
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  } = useInfiniteQuery({
    initialPageParam: 1,
    queryKey: ['all-matter-requests', params],
    queryFn: fetchAllMatterRequests,
    getNextPageParam: (lastPage, allPages) => {
      const totalCount = lastPage?.meta?.totalItems ?? 0;
      const fetchedCount = allPages.flatMap((page) => page.data).length;
      return fetchedCount < totalCount ? allPages.length + 1 : undefined;
    },
  });
  return {
    data: data?.pages.flatMap((page) => page.data) ?? [],
    isLoading,
    error,
    fetchNextPage,
    hasNextPage,
    isFetchingNextPage,
    refetch,
    isFetching,
  };
};
